









import { Vue, Component } from "vue-property-decorator";
import Dialog from "@/components/Dialog.vue";
import { Getter } from "vuex-class";

@Component({
  components: {
    Dialog,
  },
})
export default class App extends Vue {
  @Getter("show", { namespace: "dialog" }) dialog!: boolean;

  constructor() {
    super();
  }

  private beforeCreate(): void {}
  private created(): void {}
  private beforeMount(): void {}
  private mounted(): void {}
  private beforeUpdate(): void {}
  private updated(): void {}
  private destroyed(): void {}
}
